import { FormItem } from '@framework/form';
import { RowElement } from '@framework/ui';
import React from 'react';
import { ComputeExpressionInput } from '../../../expressions/compute/input/ComputeExpressionInput';
import { IWidgetComponentProps } from '../../IWidgetType';
import { WidgetType } from '../../Widget';
import { LayoutHideConfigInput } from '../common/config/LayoutHideConfigInput';
import { LayoutRemoveBorderConfigInput } from '../common/config/LayoutRemoveBorderConfigInput';
import { CodeLabelInputForm } from '../inputs/common/CodeLabelInputForm';
import { getWidgetProps } from '../inputs/common/util/getWidgetProps';
import { IComputedWidget } from './IComputedWidget';

export interface ICommonComputedWidgetConfigComponentProps
  extends IWidgetComponentProps<IComputedWidget> {
  expressionLabel?: string;
}

/**
 * Form di configurazione widget calcolati
 */
export function CommonComputedWidgetConfigComponent(
  props: ICommonComputedWidgetConfigComponentProps,
) {
  const { widget, expressionLabel } = props;
  const options = getWidgetProps(props);
  return (
    <div>
      {/* Form Codice + Etichetta */}
      <CodeLabelInputForm widgetOptions={options} />

      <FormItem
        name={['expression.raw', 'expression.value']}
        label={expressionLabel ?? 'Espressione'}
      >
        <ComputeExpressionInput
          name="expression"
          widgetId={widget.id}
          includeSelf={false}
          noFunctions={widget.type === WidgetType.ComputedString}
        />
      </FormItem>

      <RowElement>
        <LayoutHideConfigInput />
        <LayoutRemoveBorderConfigInput />
      </RowElement>
    </div>
  );
}
